<template>
    <div>
        <az-back-button :route="{name: 'credenciamentoBusca'}" text="Voltar para listagem"></az-back-button>
        <az-container>
            <credenciamento-atualizacao-acoes></credenciamento-atualizacao-acoes>
            <div class="az-tabs">
                <v-tabs left>
                    <v-tab v-for="aba in abas" :key="aba.chave" :to="construirRota(aba.nomeRota)" active-class="v-tabs__item--active secondary--text">
                        {{aba.titulo}}
                    </v-tab>
                </v-tabs>
                <router-view></router-view>
            </div>
        </az-container>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
    import {actionTypes} from '@/commons/constants'
    import CredenciamentoAtualizacaoAcoes from './acoes/CredenciamentoAtualizacaoAcoes.vue'

    export default {
        name: 'credenciamento',
        components: {CredenciamentoAtualizacaoAcoes},
        computed: {
          abas() {
            var rotas = []

            rotas = [{
              titulo: 'Dados Gerais',
              nomeRota: 'CredenciamentoAtualizacaoDadosGerais'
            },
              {
                titulo: 'Edital',
                nomeRota: 'CredenciamentoAtualizacaoEdital'
              }, {
                titulo: 'Itens',
                nomeRota: 'CredenciamentoAtualizacaoLotesItens'
              },
              {
                titulo: 'Esclarecimento/Impugnação',
                nomeRota: 'CredenciamentoEsclarecimentoImpugnacao'
              }
            ]

            if (this.$store.state.licitacao.publicado) {
              rotas.push({
                titulo: 'Seleção de Participantes',
                nomeRota: 'CredenciamentoAtualizacaoSelecaoParticipantes'
              },
              {
                titulo: 'Alterações após publicação',
                nomeRota: 'CredenciamentoTimelineEventosPosPublicacao'
              },
              {
                titulo: 'Execução',
                nomeRota: 'CredenciamentoExecucao'
              });
            }

            return rotas
          }
        },
        created() {
            if (this.$route.name !== 'CredenciamentoAtualizacaoDadosGerais') {
                this.buscarLicitacao(this.$route.params.id)
            }
        },
        mounted() {
          this.buscarRelatoriosAnalisesSolicitacoesCredenciamento(this.$route.params.id)
        },
        methods: {
            construirRota(name) {
                return {
                    name,
                    params: {id: this.$route.params.id},
                    query: this.$route.query
                }
            },
          ...mapActions({
            buscarLicitacao: actionTypes.BUSCAR_LICITACAO,
            buscarRelatoriosAnalisesSolicitacoesCredenciamento: actionTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.BUSCAR_RELATORIOS_ANALISES_SOLICITACOES_CREDENCIAMENTO,//NOSONAR
          })
        }
    }
</script>